"use client";

import { Field, Form, Formik } from "formik";
import React, { useRef, useState } from "react";
import * as Yup from "yup";
import CustomButton from "../../common/CustomButton";
import ReCAPTCHA from "react-google-recaptcha";
import { RECAPTCHA_SITE_KEY } from "../../../utils/constants";
import { verifyCaptcha } from "../../../utils/server-actions";
import PopUpModal from "../../common/PopUpModal";
import { SuccessfulPage } from "../../common/SuccessfulPage";

const ContactUSForm = () => {
  const [loading, setLoading] = useState(false);
  
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({
    title: "",
    message: "",
    status: "",
  });

  const initial = {
    name: "",
    phone: "",
    email: "",
    company: "",
    zipCode: "",
    message: "",
    registerAs: "",
  };


  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    phone: Yup.string()
      .matches(/^[0-9]{10}$/, "phone number must be exactly 10 digits")
      .required("Phone number is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    company: Yup.string().required("Company is required"),
    zipCode: Yup.string()
      .matches(/^[0-9]{6}$/, "Zip Code must be exactly 6 digits")
      .required("Zip code is required"),
    message: Yup.string().required("Message is required"),
    registerAs: Yup.string().required("Please select a location type"), // Validation for dropdown
  });

  const SectionTitle = ({ title }) => {
    return (
      <div className="t-a-c t-t-u">
        <h2>{title}</h2>
      </div>
    );
  };

  // const Label = ({ title }) => (
  //   <p
  //     className="f-w-700 color-blue"
  //     style={{
  //       marginBottom: "5px",
  //     }}
  //   >
  //     {title}
  //     <span style={{ color: "red" }}> *</span>
  //   </p>
  // );

  const handleOnSubmit = async (values, {resetForm}) => {
    console.log("form submitted:", values);
    try {
      const response = await fetch("/api/surgical-contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(values),
      });
      const api = await response.json();
      console.log("Response from API:", api);

      if (response.ok) {
        setModalData({
          title: "Successful!",
          message: "Thank you for reaching out! We'll get back to you soon.",
          status: "success",
        });
        resetForm();
      } else {
        console.log(`Error: ${api.error || "Something went wrong"}`);
        setModalData({
          title: "Error!",
          message: api.error || "Something went wrong",
          status: "err",
        });
      }
    } catch (errors) {
      setModalData({
        title: "Sorry :(",
        message: "An unexpected error occurred. Please try again later.",
        status: "err",
      });
    } finally {
      setShowModal(true);
    }
  };
  return (
    <div className="form " style={{
      height:"100%"
    }}>
      <Formik
        initialValues={initial}
        validationSchema={validationSchema}
        onSubmit={handleOnSubmit}
      >
        {({ errors, values, touched }) => {
          // console.log("Errors:", errors);
          return (
            <>
              <Form>
                <div>
                  <SectionTitle title="Contact Us" />
                </div>
                <div className="" style={{ marginTop: "30px" }}>
                  <Field
                    name="name"
                    type="text"
                    placeholder="Name"
                    className={`field-box ${
                      errors.name && touched.name ? "error" : ""
                    }`}
                  />
                  {errors.name && touched.name && (
                    <div className="error-message"></div>
                  )}

                  <Field
                    name="phone"
                    type="tel"
                    placeholder="Phone"
                    className={`field-box ${
                      errors.phone && touched.phone ? "error" : ""
                    }`}
                  />
                  {errors.phone && touched.phone && (
                    <div className="error-message"></div>
                  )}

                  <Field
                    name="email"
                    type="email"
                    placeholder="Email"
                    className={`field-box ${
                      errors.email && touched.email ? "error" : ""
                    }`}
                  />
                  {errors.email && touched.email && (
                    <div className="error-message"></div>
                  )}
                  <Field
                    name="company"
                    type="text"
                    placeholder="Company"
                    className={`field-box ${
                      errors.company && touched.company ? "error" : ""
                    }`}
                  />
                  {errors.company && touched.company && (
                    <div className="error-message"></div>
                  )}

                  <Field
                    name="zipCode"
                    type="tel"
                    placeholder="Zip Code"
                    className={`field-box ${
                      errors.zipCode && touched.zipCode ? "error" : ""
                    }`}
                  />
                  {errors.zipCode && touched.zipCode && (
                    <div className="error-message"></div>
                  )}

                  <Field
                    as="select"
                    name="registerAs"
                    className={`field-box ${
                      errors.registerAs && touched.registerAs ? "error" : ""
                    }`}
                  >
                    <option value="">Register As</option>
                    <option value="hospital">Hospital</option>
                    <option value="ambulatory">
                      Ambulatory Surgery Center
                    </option>
                    <option value="nurse">Nurse Practitioner</option>
                    <option value="physician">Physician Assistant</option>
                    <option value="surgeon">
                      Surgeon and Surgical Assistant
                    </option>
                    <option value="other">Other</option>
                  </Field>
                  {errors.registerAs && touched.registerAs && (
                    <div className="error-message"></div>
                  )}

                  <Field
                    name="message"
                    as="textarea"
                    placeholder="Message"
                    className={`field-textbox  ${
                      errors.message && touched.message ? "error" : ""
                    }`}
                  />
                  {errors.message && touched.message && (
                    <div className="error-message"></div>
                  )}

                  {/* <ReCAPTCHA
                ref={recaptchaRef}
                size="normal"
                sitekey={RECAPTCHA_SITE_KEY}
                onChange={handleCaptchaSubmission}
              /> */}

                  <div style={{ marginTop: "10px" }}>
                    <CustomButton
                      style={{ width: "100%" }}
                      type="submit"
                      theme="primary"
                      disabled={
                        loading ||
                        !values.name ||
                        !values.phone ||
                        !values.email ||
                        !values.company ||
                        !values.zipCode ||
                        !values.registerAs ||
                        !values.message
                      }
                      title="Submit Now"
                    />
                  </div>
                </div>
              </Form>
              {showModal && (
                <PopUpModal onClose={() => setShowModal(false)}>
                  <SuccessfulPage
                    modalData={modalData}
                    onClose={() => setShowModal(false)}
                  />
                </PopUpModal>
              )}
            </>
          );
        }}
      </Formik>
    </div>
  );
};

export default ContactUSForm;
